import { trackAnalyticsEvent } from '../../utils/track-analytics-event.js';

class RefiIdpTokenRefresh extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.secondsToRefresh = 840;
    this.refreshUrl = '';
    this.activityDetected = false;
    this.setRefreshInterval();
    this.setActivityDetected = () => {
      this.activityDetected = true;
    };
  }

  static get observedAttributes() {
    return ['refresh-url', 'seconds-to-refresh'];
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = '<slot></slot>';
    this.setRefreshInterval();
    document.addEventListener('keydown', this.setActivityDetected);
    document.addEventListener('click', this.setActivityDetected);
  }

  disconnectedCallback() {
    window.clearInterval(this.refreshInterval);
    document.removeEventListener('keydown', this.setActivityDetected);
    document.removeEventListener('click', this.setActivityDetected);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'refresh-url':
        this.refreshUrl = newValue;
        break;
      case 'seconds-to-refresh':
        this.secondsToRefresh = newValue;
        break;
      case 'clear-session':
        this.clearSession = newValue;
        break;
      // no default case
    }
  }

  getNewToken() {
    if (this.refreshIframe) {
      document.body.removeChild(this.refreshIframe);
    }
    this.refreshIframe = document.createElement('iframe');
    this.refreshIframe.style.display = 'none';
    this.refreshIframe.setAttribute('src', this.refreshUrl);
    document.body.appendChild(this.refreshIframe);
    if (this.refreshIframe.contentWindow.location.href) {
      const isFailure = this.refreshIframe.contentWindow.location.href.endsWith('/login');

      if (isFailure && this.clearSession && sessionStorage.getItem(this.clearSession)) {
        sessionStorage.removeItem(this.clearSession);
      }
    }
  }

  handleRefresh() {
    if (this.activityDetected) {
      trackAnalyticsEvent('refresh_idp_token');
      this.activityDetected = false;
      this.getNewToken();
    }
  }

  setRefreshInterval() {
    this.refreshInterval = setInterval(() => this.handleRefresh(), this.secondsToRefresh * 1000);
  }
}

export { RefiIdpTokenRefresh };
